/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { CheckLogin, GetAllContracts } from "../../API/Pins";
import { store } from "../../Context/Store";
import { Redirect } from "react-router-dom";
import Table from "../../Components/Table";
import { columns } from "./columns";
import useModal from "../../utils/hooks";
import Modal from "../../Components/Modal";
import AddContractModal from "../../Components/AddContractModal";

const ContractsDashboard = ({ history }) => {
  const [query, setQuery] = useState({})


  const { OpenModal: addContract, toggle: toggleAddContract, close: closeAddModal } = useModal();
  const { OpenModal: editContract, toggle: toggleEditContract, close: closeEditModal } = useModal();

  const context = useContext(store);
  const { dispatch } = context;

  const TableRef = useRef();

  const [CheckAuth, setCheckAuth] = useState(true);
  const [Contracts, setContracts] = useState([]);
  const [EditContract, setEditContract] = useState(null);

  useEffect(() => {
    if (EditContract) {
      toggleEditContract();
    }
  }, [EditContract]);

  useEffect(() => {
    const CheckAuth = async () => {
      try {
        const res = await CheckLogin();
        if (res?.data?.role === "Admin") {
          dispatch({ type: "SET_ROLE", role: res?.data?.role });
          setCheckAuth(res?.data?.role);
        }
      } catch (error) {
        setCheckAuth(false);
      }
    };

    CheckAuth();
  }, []);

  const FetchAllContracts = async (query) => {
    try {
      if (CheckAuth === "Admin") {
        const plan = await GetAllContracts(query);
        setContracts(plan?.data);
      }
    } catch (error) {
      setContracts([]);
    }
  };

  useEffect(() => {
    FetchAllContracts(query);
  }, [CheckAuth, query]);

  if (!CheckAuth) {
    return <Redirect to="/login" />;
  }

  return (
    <div className="flex flex-col">
      <div className="w-full py-6 px-4 flex items-center justify-between">
        <div className="flex items-center">
          <span
            className="mx-4 text-base font-medium cursor-pointer"
            onClick={() => history.push("/")}
          >
            Maps
          </span>
          <span
            className="mx-4 text-base font-medium cursor-pointer"
            onClick={() => history.push("/admin/users")}
          >
            Users
          </span>
          <span className="mx-4 text-base font-medium cursor-pointer text-blue">
            Contracts
          </span>
        </div>
        <div
          onClick={toggleAddContract}
          className="text-blue text-lg font-medium cursor-pointer"
        >
          + Add Contract
        </div>
      </div>
      <Table
        columns={columns(dispatch, setEditContract)}
        // tableFetchApi={getOrganizationsAPI}
        tableData={Contracts}
        setQuery={setQuery}
        tableLoading={false}
        tableName="contracts-list"
        ref={TableRef}
      />

      {(addContract || editContract) && (
        <Modal
          title={
            EditContract
              ? `Edit ${EditContract.username} Contract`
              : "Add Contract"
          }
          closeModal={() => {
            console.log("modal closed")
            closeEditModal()
            closeAddModal()
            setEditContract(null);
          }}
        >
          <AddContractModal
            closeModal={() => {
              closeAddModal()
              closeEditModal()
              setEditContract(null);
            }}
            refetchData={FetchAllContracts}
            editMode={EditContract}
          />
        </Modal>
      )
      }
    </div >
  );
};

export default ContractsDashboard;
